import React from 'react';
import { Drawer, List, Avatar, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import type { CustomerDTO } from '../../services/customers';

type Props = {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  items: CustomerDTO[];
  onOpenCustomerViews: (customerId: number) => void;
};

const ViewsReminderDrawer: React.FC<Props> = ({
  open,
  onClose,
  loading = false,
  items,
  onOpenCustomerViews,
}) => {
  return (
    <Drawer
      title="Clienti senza views negli ultimi 30 giorni"
      open={open}
      onClose={onClose}
      width={640}
      destroyOnClose
    >
      <List
        loading={loading}
        dataSource={items}
        locale={{ emptyText: 'Nessun cliente da ricordare' }}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                key="open-views"
                onClick={() => onOpenCustomerViews(item.id!)}
              >
                Apri views
              </Button>,
            ]}
          >
            <List.Item.Meta
              avatar={<Avatar icon={<UserOutlined />} />}
              title={item.businessName}
              description={item.email || '—'}
            />
          </List.Item>
        )}
      />
    </Drawer>
  );
};

export default ViewsReminderDrawer;
